import React from 'react';
import { TaskNotesModalTemplate } from 'themes/application/facility-order/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { TaskNotesModalViewStore } from 'application/facility-order/stores';

@setCurrentView((rootStore, componentProps) => new TaskNotesModalViewStore(rootStore, componentProps), 'taskNotesModalViewStore')
@observer
class TaskNotesModal extends React.Component {
    render() {
        return <TaskNotesModalTemplate {...this.props} />
    }
}

export default TaskNotesModal;